<template>
  <v-simple-table fixed-header>
    <template v-slot:default>
      <thead>
        <tr>
          <th :colspan="3" class="grey lighten-2 font-weight-bold subtitle-1">
            <div class="row">
              <span>{{ $t("LEAD_SENTENCE") }}</span>
              <v-spacer />
              <div
                v-if="
                  _.findIndex(editDetailSection.lead_sentence, [
                    'edit',
                    true,
                  ]) != -1
                "
              >
                <v-btn small @click="handleCancel">{{ $t("CANCEL") }}</v-btn>
                <v-btn
                  small
                  class="mx-3 primary"
                  @click="handleUpdate"
                  :loading="loading"
                  >保存</v-btn
                >
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(lead_sentence, index) in editDetailSection.lead_sentence"
          :key="lead_sentence.key"
        >
          <td class="width-2">
            <strong>{{ lead_sentence.text }}</strong>
          </td>
          <td
            style="cursor: text"
            @click="handleEdit(lead_sentence)"
            :key="`lead_sentence-${index}-${tbody_lead_sentence}`"
          >
            <span class="pre-wrap" v-if="!lead_sentence.edit">{{
              lead_sentence.value
            }}</span>
            <v-textarea
              solo
              v-else
              v-model="lead_sentence.value"
              :auto-grow="true"
              hide-details
              class="my-2"
              autofocus
              rows="2"
            />
          </td>
        </tr>
      </tbody>
    </template>
  </v-simple-table>
</template>
<script>
import { updateSection } from "@/api/Section.api";
export default {
  store: ["editDetailSection"],
  data() {
    return {
      tbody_lead_sentence: 0,
      loading: false,
    };
  },
  methods: {
    handleEdit(lead_sentence) {
      // lead_sentence
      // if (
      //   !this.editDetailSection.status["key"] ||
      //   this.editDetailSection.status["key"] == "lead_sentence"
      // ) {
      //   console.log("-1---");
      //   lead_sentence.edit = true;
      //   this.editDetailSection.status["key"] = "lead_sentence";
      // } else {
      //   console.log("----");
      //   this.editDetailSection.status["status"] = true;
      // }
      let checkEdit = this.editDetailSection.goal.find((e) => e.edit == true);
      if (checkEdit) {
        this.editDetailSection.statusEdit = true;
      } else {
        lead_sentence.edit = true;
        this.editDetailSection.isEdit = "lead_sentence";
      }
    },
    handleCancel() {
      this.$emit("setDefault");
      this.editDetailSection.lead_sentence.forEach((e) => {
        e.edit = false;
      });
      this.editDetailSection.statusEdit = false;
      this.editDetailSection.isEdit = "";
    },
    async handleUpdate() {
      this.loading = true;
      let lead_sentence = {};
      this.editDetailSection.lead_sentence.forEach((e) => {
        lead_sentence[e.key] = e.value;
      });
      let params = {
        sub_key: this.$route.params.chapter,
        id: this.$route.params.section,
        lead_sentence,
      };
      this.loadingListSection = true;
      await updateSection(params)
        .then(async () => {
          this.editDetailSection.lead_sentence.forEach((e) => {
            e.edit = false;
          });
          this.editDetailSection.statusEdit = false;
          this.editDetailSection.isEdit = "lead_sentence";
        })
        .catch(() => {
          // this.loaddingEditLeadSentence = false;
        });
      this.loading = false;
    },
  },
};
</script>
<style  scoped>
::v-deep tr td {
  border: 1px solid #ccc;
  border-top: none;
}
::v-deep tr th {
  border: 1px solid #ccc;
  border-bottom: none;
}
.theme--light.v-data-table
  > .v-data-table__wrapper
  > table
  > tbody
  > tr:hover:not(.v-data-table__expanded__content):not(.v-data-table__empty-wrapper) {
  background: #ffffff !important;
}
</style>